import type { ListingTrackingContext } from './types';

interface BuildCarouselTrackingContextInput {
	placement: string;
	/** Only `.length` is read. */
	properties: { length: number } | null | undefined;
	originProperty?: string | null;
}

// For static carousels (no filters, no pagination): `total === perPage`
// equals rendered cards so `positionInList + 1` matches the visual position.
export function buildCarouselTrackingContext(
	input: BuildCarouselTrackingContextInput
): ListingTrackingContext {
	const total = input.properties?.length ?? 0;

	return {
		placement: input.placement,
		originProperty: input.originProperty ?? null,
		appliedFilters: {},
		total,
		page: 1,
		perPage: total
	};
}
